import React from 'react'

const TablaPrincipalListaDiagnosticoPostoperatorio = ({item,passDiaPost}) => {
    const infoPost={
        codigoDiagnostico:item.DMCodi,
        nombreDiagnostico:item.DMNomb
    }
    const handleOnclickPost=()=>{
        passDiaPost(infoPost)
    }
  return (
    <tr key={item.DMCodi} className="border-b bg-white" >
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
            onClick={handleOnclickPost}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.DMCodi}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.DMNomb}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.PClCod}
      </td>
      
    </tr>
  )
}

export default TablaPrincipalListaDiagnosticoPostoperatorio